import { Injectable } from '@angular/core';
import * as queries from '@app/core/graphql/queries';
import {
    CreateProviderInput,
    Provider,
    UpdateProviderInput
} from '@app/core/services/api/API.service';

import { generateClient } from '@aws-amplify/api';
import * as mutations from '@graphql/mutations';

@Injectable({
    providedIn: 'root'
})
export class ProviderService {
    constructor() {}
    private amplifyClient = generateClient();

    async listProviders(): Promise<Provider[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listProviders
                })
            ).data.listProviders.items;
            if (data) return data as Provider[];
        } catch (error) {
            console.error('Error finding Provider', error);
            return null;
        }
    }

    async getProvider(id: string): Promise<Provider> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getProvider,
                    variables: { id }
                })
            ).data.getProvider;
            if (data) return data as Provider;
        } catch (error) {
            console.error('Error finding Provider', error);
            return null;
        }
    }

    async createProvider(input: CreateProviderInput): Promise<Provider> {
        try {
            const provider = (
                await this.amplifyClient.graphql({
                    query: mutations.createProvider,
                    variables: {
                        input
                    }
                })
            ).data.createProvider;
            if (provider) return provider as Provider;
        } catch (error) {
            console.error('Error creating provider', error);
            return null;
        }
    }
    async updateProvider(input: UpdateProviderInput): Promise<Provider> {
        try {
            const provider = (
                await this.amplifyClient.graphql({
                    query: mutations.updateProvider,
                    variables: {
                        input
                    }
                })
            ).data.updateProvider;
            if (provider) return provider as Provider;
        } catch (error) {
            console.error('Error updating providers', error);
            return null;
        }
    }
}
